import axios from 'axios';

export default {


   async InsertOrUpdateProduct(params) {
      return await axios.post(process.env.VUE_APP_FIXIT_NO_BOOKING_URL + '/api/Cart/insert-or-update-product', params);
   },

   async GetShoppingCart(params) {
      return await axios.post(process.env.VUE_APP_FIXIT_NO_BOOKING_URL + '/api/Cart/get-shopping-cart', params);
   },
   async GetShoppingCarts(params) {
      return await axios.post(process.env.VUE_APP_FIXIT_NO_BOOKING_URL + '/api/Cart/get-shopping-carts', params);
   },
   async RemoveItemFromCart(params) {
      return await axios.post(process.env.VUE_APP_FIXIT_NO_BOOKING_URL + '/api/Cart/delete-shopping-cart-item', params);
   },
   async DropShoppingCart(params) {
      return await axios.get(process.env.VUE_APP_FIXIT_NO_BOOKING_URL + '/api/Cart/drop-active-cart', params);
   },
};
